import { useMemo } from 'react'
import { isFinite } from 'lodash'
import useSWR from 'swr'
import { useUpdaterChainId } from '~/hooks'
import { useFeeData } from '~/state/application/hooks'
import { useTokenlonV6NetworkConfig } from '~/state/dex/hooks'
import { getGasPrice } from '~/apis'
import { isMainnetOrSepolia } from '~/utils/chain'

export const useGasPrice = () => {
  const chainId = useUpdaterChainId()
  const isMainnetOrSepoliaFlag = isMainnetOrSepolia(chainId)

  const { gasPriceScale: networkGasPriceScale } = useTokenlonV6NetworkConfig()
  const gasPriceScale =
    !isMainnetOrSepoliaFlag &&
    networkGasPriceScale &&
    isFinite(networkGasPriceScale)
      ? networkGasPriceScale * 100
      : 100

  const { data: feeGears } = useSWR(
    isMainnetOrSepoliaFlag ? 'getGasPrice' : null,
    getGasPrice,
    {
      refreshInterval: 10000,
    },
  )
  const tokenlonFee = feeGears?.extra?.tokenlon
  const feeData = useFeeData()

  const gasPriceWithScale = useMemo(() => {
    const gasPrice =
      tokenlonFee?.maxFeePerGas || feeData?.gasPrice?.toString() || '0'
    return (BigInt(gasPrice) * BigInt(gasPriceScale)) / 100n
  }, [tokenlonFee?.maxFeePerGas, feeData?.gasPrice, gasPriceScale])

  const quoteGasPrice = BigInt(
    tokenlonFee?.gasPrice || feeData?.gasPrice?.toString() || '0',
  )
  const maxPriorityFeePerGas = BigInt(tokenlonFee?.maxPriorityFeePerGas || '0')

  return {
    quoteGasPrice,
    gasPriceWithScale,
    maxPriorityFeePerGas,
  }
}
